module.exports = __webpack_public_path__ + "img/202112271048530035mh.1d2734fc.png";